import { CommandType } from "~app/common/services/cqs/CommandType";
import { AnmalanTradslagBaseCommand } from "./AnmalanTradslagBaseCommand";

export class AddAnmalanTradslagCommand extends AnmalanTradslagBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddAnmalanTradslagCommand";

    constructor(atgardGuid: string, anmalanTradslagGuid: string) {
        super(atgardGuid, anmalanTradslagGuid, AddAnmalanTradslagCommand.$type, CommandType.Insert);
    }
}
